import * as types from './types';

const getBumexFeature = keyFeature => ({
  type: types.GET_BUMEX_FEATURE,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/bumexFeatures?keyFeature=${keyFeature}`,
    method: 'GET',
    keyFeature
  }
});

// usar este metodo agregando la key de la BF a obtener en el archivo -> packages/panel/src/constants/bumexFeatures.js
const getBumexFeatureBulk = keyFeatures => ({
  type: types.GET_BUMEX_FEATURE_BULK,
  meta: {
    async: true,
    blocking: false,
    api: 'avisos',
    path: `/bumexFeatures/bulk?keyFeatures=${keyFeatures.join(',')}`,
    method: 'GET',
    keyFeatures
  }
});

export { getBumexFeature, getBumexFeatureBulk };
